export enum WorkOrderMenuItem {
    Maintenance = 0,
    ServiceConnection = 1,
    SiteVerification = 2,
}